import Vue from "vue";
import { SET_OFFERS_FILTER } from "../../store/modules/offerModule";
import store from "../../store/store";
import useSessionStorage from '../helpers/useSessionStorage'

class OfferService {

    get cacheKeys() {
        return { 
            activeOfferKey: "mo-cpl-active-offers"
        }
    }

    /**
     * Get list offers active for /offers page
     * 
     * @param {{ params: Object, force: boolean }} args
     * @returns Promise 
     */
    async lists(args = { params: {}, force: false, }) {
        let activeOffers = [];
        const { getSessionStorage, setSessionStorage } = useSessionStorage(offerService.cacheKeys.activeOfferKey);
        
        try {
            if(!getSessionStorage() || args.force) {
                const rs = await Vue.axios.post("/offer/list");

                activeOffers = rs.data.map(item => {
                    return {
                        name: item.name,
                        code: item.offer_id,
                        offer_id: item.offer_id,
                        full_name: item.name,
                        avatar: item.hasOwnProperty("meta") && item.meta.hasOwnProperty("avatar") ? item.meta.avatar : "",
                        access_type: item.access_type,
                        access_status: item.access_status,
                        meta: item.meta,
                        paused: item.paused,
                        approve_status: item.approve_status,
                        status_text: item.status_text,
                        is_running: item.is_running,
                        is_pending: item.is_pending,
                        is_unregister: item.is_unregister,
                        is_paused: item.is_paused,
                        is_locked: item.is_locked,
                        total_publishers_register: item.total_publishers_register,
                        updated_at: item.updated_at,
                        category_id: item.hasOwnProperty("category_id") ? item.category_id : ""
                    }
                });

                setSessionStorage(activeOffers);
                return activeOffers;
            }
            else {
                return getSessionStorage();
            }
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * To send a request to signup a offer,
     * Allow the user was signup to run campaign with their offer sign up.
     * 
     * @param {{ offer_id: string, request_message: string, advertisement_ids: string }} data
     * @returns {Promise}
     */
    async signupOffer(data = {}) {
        try {
            return await Vue.axios.post("/offer/pub-request-offer", data);
        } catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * Get flags offer
     * 
     * @returns {Promise}
     */
    async flags() {
        try {
            return await Vue.axios.get("/offer/flags");
        } catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * Get relates offer
     * 
     * @returns {Promise}
     */
    async relates() {
        try {
            return await Vue.axios.get("/offer/relate");
        } catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description To submit request create tracking url for offer
     * @param {{trackingUrl,parkingDomains,selectedDomain,clickUrl,selectedSsl,pathCustom,landing_page}} data 
     * @returns 
     */
    async generateTrackingUrlCpl(data = {}) {
        try {
            return await Vue.axios.post("/offer/generate-tracking-url-cpl", data);
        }
        catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description Get offer list filtered
     * @param {{ publisherId }} data 
     * @returns 
     */
    async offerFilter(data = {}) {
        try {
            // Get caching offer filter in store vuex
            const offersFilter = store.state.offers.filters || [];
            if(offersFilter.length) {
                // If caching in store vuex exist, to return
                return Promise.resolve({ data: offersFilter })
            }
            else {
                // By the way, to fetch in api and cache it to store vuex
                const response = await Vue.axios.post("/offer/offer-filter");
                // Store it to offers list in vuex
                store.dispatch(SET_OFFERS_FILTER, response.data);

                return response;
            }
        } catch(e) {
            return Promise.reject(e);
        }
    }

    async getInfoTcForm(data = {}) {
        try {
            return await Vue.axios.get(`/offer/tc-form/${data}`);
        }
        catch(e) {
            return Promise.reject(e);
        }
    }
}

const offerService = new OfferService();

export default offerService;


// WEBPACK FOOTER //
// ./src/core/services/offerService.js